import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

const RedirectToAnswerPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const to = navigation.processes.surveys.id.answer.fullPath({ id })

  return <Navigate to={to} />
}

export default RedirectToAnswerPage
